export const TAG_FQN_PREFIXES = {
  TIER: 'Tier.',
  CERTIFICATION: 'Certification.',
} as const;

export type TagFqnPrefix = (typeof TAG_FQN_PREFIXES)[keyof typeof TAG_FQN_PREFIXES];
